var _ellipse, _g, _ellipse2, _rect, _g2, _g3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamsEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 434,
    viewBox: "0 0 533 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.18,
    filter: "url(#filter0_f_2761_394708)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.704,
    cy: 152.097,
    rx: 101.622,
    ry: 99.8077,
    fill: "#49E0B3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter1_f_2761_394708)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.997,
    cy: 207.674,
    r: 96.1783,
    fill: "#190DA0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.43,
    filter: "url(#filter2_f_2761_394708)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.244,
    cy: 233.023,
    rx: 119.769,
    ry: 118.862,
    fill: "#5B4B9B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145.355,
    y: 103.812,
    width: 236.724,
    height: 236.724,
    rx: 118.362,
    fill: "url(#paint0_linear_2761_394708)",
    fillOpacity: 0.4,
    stroke: "url(#paint1_linear_2761_394708)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.142 248.447V273.853",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.439 261.15H472.845",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.365 299.108V313.928",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.956 306.518H445.776",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.503 61.7812V115.768",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51 88.7744H165.497",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2761_394708)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.918,
    y: 157.31,
    width: 250,
    height: 80,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 96.918,
    y: 167.31,
    width: 60,
    height: 60,
    rx: 6,
    fill: "#B2D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.707 207.004C142.889 207.005 142.096 207.283 141.456 207.792C140.815 208.301 140.366 209.011 140.18 209.807H130.653C130.498 209.149 130.163 208.547 129.685 208.069C129.207 207.59 128.605 207.255 127.946 207.101V202.32H140.96C142.392 202.32 143.765 201.751 144.778 200.738C145.79 199.726 146.359 198.353 146.359 196.921C146.359 195.489 145.79 194.116 144.778 193.104C143.765 192.091 142.392 191.522 140.96 191.522H140.21C139.679 189.955 138.574 188.647 137.118 187.862C135.662 187.076 133.962 186.871 132.361 187.288C131.52 185.226 129.989 183.521 128.029 182.463C126.07 181.406 123.805 181.061 121.619 181.488C119.434 181.916 117.466 183.089 116.049 184.807C114.633 186.525 113.857 188.681 113.855 190.907C113.855 191.108 113.862 191.312 113.878 191.522H113.292C111.86 191.522 110.487 192.09 109.475 193.103C108.462 194.115 107.894 195.488 107.894 196.92C107.894 198.352 108.462 199.725 109.475 200.737C110.487 201.75 111.86 202.319 113.292 202.319H126.306V207.1C125.647 207.254 125.045 207.59 124.567 208.068C124.089 208.546 123.753 209.148 123.599 209.807H114.072C113.87 208.94 113.357 208.178 112.63 207.665C111.903 207.152 111.013 206.925 110.129 207.027C109.245 207.128 108.43 207.551 107.837 208.215C107.245 208.879 106.918 209.737 106.918 210.627C106.918 211.516 107.245 212.375 107.837 213.039C108.43 213.703 109.245 214.126 110.129 214.227C111.013 214.328 111.903 214.101 112.63 213.589C113.357 213.076 113.87 212.314 114.072 211.447H123.599C123.784 212.244 124.233 212.955 124.873 213.464C125.514 213.974 126.308 214.251 127.126 214.251C127.944 214.251 128.738 213.974 129.379 213.464C130.019 212.955 130.468 212.244 130.653 211.447H140.18C140.335 212.111 140.673 212.717 141.157 213.197C141.64 213.677 142.25 214.011 142.914 214.161C143.579 214.31 144.273 214.269 144.915 214.042C145.558 213.815 146.123 213.412 146.547 212.878C146.97 212.344 147.235 211.702 147.31 211.025C147.385 210.347 147.267 209.663 146.971 209.049C146.674 208.436 146.211 207.918 145.633 207.556C145.056 207.194 144.388 207.003 143.707 207.003V207.004ZM110.545 212.611C110.153 212.611 109.77 212.495 109.443 212.277C109.117 212.059 108.863 211.749 108.713 211.387C108.563 211.024 108.524 210.626 108.6 210.241C108.677 209.856 108.866 209.503 109.143 209.225C109.42 208.948 109.774 208.759 110.158 208.683C110.543 208.606 110.942 208.645 111.304 208.795C111.667 208.946 111.976 209.2 112.194 209.526C112.412 209.852 112.529 210.236 112.529 210.628C112.528 211.154 112.319 211.658 111.947 212.029C111.575 212.401 111.071 212.61 110.545 212.611ZM113.292 200.678C112.296 200.678 111.34 200.282 110.635 199.577C109.93 198.873 109.534 197.917 109.534 196.92C109.534 195.923 109.93 194.968 110.635 194.263C111.34 193.558 112.296 193.162 113.292 193.162H114.804C114.923 193.162 115.04 193.136 115.148 193.086C115.256 193.036 115.352 192.963 115.429 192.873C115.506 192.782 115.562 192.676 115.594 192.562C115.626 192.447 115.633 192.327 115.613 192.21C115.282 190.218 115.72 188.175 116.838 186.494C117.956 184.813 119.671 183.619 121.636 183.155C123.601 182.691 125.669 182.991 127.421 183.994C129.173 184.997 130.479 186.628 131.074 188.558C131.107 188.666 131.163 188.767 131.237 188.853C131.311 188.939 131.403 189.008 131.505 189.057C131.608 189.106 131.719 189.133 131.833 189.136C131.947 189.14 132.06 189.119 132.165 189.077C132.823 188.809 133.532 188.688 134.241 188.721C134.951 188.755 135.645 188.942 136.275 189.27C136.906 189.598 137.457 190.059 137.892 190.621C138.326 191.183 138.633 191.833 138.792 192.526C138.834 192.706 138.935 192.867 139.08 192.983C139.224 193.098 139.404 193.161 139.589 193.162H140.959C141.955 193.162 142.911 193.558 143.616 194.263C144.321 194.968 144.717 195.923 144.717 196.92C144.717 197.917 144.321 198.873 143.616 199.577C142.911 200.282 141.955 200.678 140.959 200.678H113.292ZM127.126 212.611C126.734 212.611 126.35 212.495 126.024 212.277C125.698 212.059 125.444 211.749 125.294 211.386C125.144 211.024 125.105 210.625 125.181 210.241C125.258 209.856 125.447 209.503 125.724 209.225C126.002 208.948 126.355 208.759 126.74 208.683C127.124 208.606 127.523 208.645 127.885 208.796C128.248 208.946 128.558 209.2 128.775 209.526C128.993 209.852 129.11 210.236 129.11 210.628C129.109 211.154 128.9 211.658 128.528 212.03C128.156 212.401 127.652 212.611 127.126 212.611ZM143.707 212.611C143.315 212.611 142.931 212.495 142.605 212.277C142.279 212.059 142.025 211.749 141.875 211.386C141.725 211.024 141.686 210.625 141.762 210.241C141.839 209.856 142.028 209.503 142.305 209.225C142.583 208.948 142.936 208.759 143.321 208.683C143.705 208.606 144.104 208.645 144.467 208.796C144.829 208.946 145.139 209.2 145.357 209.526C145.574 209.852 145.691 210.236 145.691 210.628C145.69 211.154 145.481 211.658 145.109 212.03C144.737 212.401 144.233 212.611 143.707 212.611Z",
    fill: "#65AAA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.918,
    y: 194.31,
    width: 160,
    height: 6,
    fill: "#F2F2F7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2761_394708)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.918,
    y: 88.3096,
    width: 250,
    height: 80,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 241.918,
    y: 98.3096,
    width: 60,
    height: 60,
    rx: 6,
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.793 114.325C291.199 114.325 292.277 113.153 292.277 111.794C292.277 110.435 291.152 109.356 289.793 109.31H254.449C253.043 109.31 251.965 110.481 251.965 111.841C251.965 113.2 253.09 114.278 254.449 114.325H254.871V134.388H254.449C253.043 134.388 251.918 135.513 251.918 136.919C251.918 138.325 253.043 139.45 254.449 139.45H271.277V142.028C270.105 142.497 269.496 143.81 269.965 144.981C270.434 146.153 271.746 146.763 272.918 146.294C274.09 145.825 274.699 144.513 274.23 143.341C273.996 142.731 273.527 142.263 272.918 142.028V139.45H289.746C291.152 139.45 292.277 138.325 292.277 136.919C292.277 135.513 291.152 134.388 289.746 134.388H289.324V114.325H289.793ZM272.121 144.747C271.746 144.747 271.465 144.466 271.465 144.091C271.465 143.716 271.746 143.435 272.121 143.435C272.496 143.435 272.777 143.716 272.777 144.091C272.777 144.466 272.496 144.747 272.121 144.747ZM289.793 136.028C290.262 136.028 290.684 136.403 290.684 136.919C290.684 137.388 290.309 137.81 289.793 137.81H254.449C253.98 137.81 253.559 137.435 253.559 136.919C253.559 136.45 253.934 136.028 254.449 136.028H289.793ZM256.559 134.388V114.325H287.73V134.388H256.559ZM254.449 112.685C253.98 112.685 253.605 112.263 253.605 111.794C253.605 111.325 253.98 110.95 254.449 110.95H289.746C290.215 110.95 290.59 111.372 290.59 111.841C290.59 112.31 290.215 112.685 289.746 112.685C283.746 112.685 258.996 112.685 254.449 112.685Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.137 118.45C273.809 118.122 273.293 118.122 272.965 118.45L270.387 121.028C270.059 121.356 270.059 121.872 270.387 122.2C270.715 122.528 271.23 122.528 271.512 122.2L272.684 121.028V123.325C272.684 126.372 270.199 128.856 267.152 128.856C266.684 128.856 266.309 129.231 266.309 129.7C266.309 130.169 266.684 130.544 267.152 130.544C271.137 130.544 274.324 127.31 274.324 123.372V121.028L275.496 122.2C275.824 122.528 276.34 122.528 276.668 122.2C276.996 121.872 276.996 121.356 276.668 121.075L274.137 118.45Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.309 117.231C261.621 117.231 260.215 118.638 260.215 120.325C260.215 122.013 261.621 123.419 263.309 123.419C264.996 123.419 266.402 122.013 266.402 120.325C266.402 118.591 264.996 117.231 263.309 117.231ZM263.309 121.778C262.512 121.778 261.855 121.122 261.855 120.325C261.855 119.528 262.512 118.872 263.309 118.872C264.105 118.872 264.762 119.528 264.762 120.325C264.762 121.122 264.105 121.778 263.309 121.778Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.949 126.372C282.621 126.044 282.105 126.044 281.777 126.372L280.746 127.403L279.715 126.372C279.387 126.044 278.871 126.044 278.543 126.372C278.215 126.7 278.215 127.216 278.543 127.544L279.574 128.575L278.543 129.606C278.215 129.935 278.215 130.45 278.543 130.778C278.871 131.106 279.387 131.106 279.715 130.778L280.746 129.747L281.777 130.778C282.105 131.106 282.621 131.106 282.949 130.778C283.277 130.45 283.277 129.935 282.949 129.606L281.918 128.575L282.949 127.544C283.277 127.216 283.277 126.7 282.949 126.372Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.918,
    y: 125.31,
    width: 160,
    height: 6,
    fill: "#F2F2F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2761_394708)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.918,
    y: 245.31,
    width: 250,
    height: 80,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 146.918,
    y: 255.31,
    width: 60,
    height: 60,
    rx: 6,
    fill: "#F3DF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.762 305.716H192.402C192.871 305.716 193.246 305.341 193.246 304.872V274.263C193.246 274.028 193.152 273.841 193.012 273.7L184.855 265.544C184.715 265.403 184.527 265.31 184.293 265.31H160.762C160.293 265.31 159.965 265.685 159.918 266.153V304.919C159.965 305.341 160.293 305.716 160.762 305.716ZM185.09 268.122C186.965 269.997 188.559 271.591 190.434 273.466H185.09V268.122ZM161.605 266.95H183.496V274.263C183.496 274.731 183.871 275.06 184.34 275.106H191.652V304.075H161.652V266.95H161.605Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.012 284.716H185.887C185.465 280.169 181.902 276.606 177.402 276.231V275.106C177.402 274.638 177.027 274.263 176.559 274.263C176.09 274.263 175.715 274.638 175.715 275.106V276.231C171.215 276.653 167.652 280.216 167.23 284.716H166.152C165.684 284.716 165.309 285.091 165.309 285.56C165.309 286.028 165.684 286.403 166.152 286.403H167.277C167.699 290.903 171.262 294.466 175.762 294.888V296.013C175.762 296.481 176.137 296.856 176.605 296.856C177.074 296.856 177.449 296.481 177.449 296.013V294.888C181.949 294.466 185.512 290.903 185.934 286.403H187.059C187.527 286.403 187.902 286.028 187.902 285.56C187.902 285.091 187.48 284.716 187.012 284.716ZM183.215 286.356H184.246C183.871 289.966 181.012 292.825 177.402 293.2V292.169C177.402 291.7 177.027 291.325 176.559 291.325C176.09 291.325 175.715 291.7 175.715 292.169V293.2C172.105 292.825 169.246 289.966 168.871 286.356H169.902C170.371 286.356 170.746 285.981 170.746 285.513C170.746 285.044 170.371 284.669 169.902 284.669H168.871C169.246 281.06 172.105 278.2 175.715 277.825V278.856C175.715 279.325 176.09 279.7 176.559 279.7C177.027 279.7 177.402 279.325 177.402 278.856V277.825C181.012 278.2 183.871 281.06 184.246 284.669H183.215C182.746 284.669 182.371 285.044 182.371 285.513C182.371 285.981 182.746 286.356 183.215 286.356Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.605 282.138C174.777 282.138 173.277 283.638 173.277 285.513C173.277 287.388 174.777 288.888 176.605 288.888C178.434 288.888 179.98 287.388 179.98 285.513C179.934 283.685 178.434 282.185 176.605 282.138ZM176.605 287.247C175.668 287.247 174.918 286.497 174.918 285.513C174.918 284.528 175.668 283.825 176.652 283.825C177.59 283.825 178.34 284.575 178.34 285.513C178.293 286.45 177.543 287.2 176.605 287.247Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.918,
    y: 282.31,
    width: 160,
    height: 6,
    fill: "#F2F2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2761_394708",
    x: 22.082,
    y: 0.289551,
    width: 307.245,
    height: 303.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_2761_394708"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2761_394708",
    x: 175.819,
    y: 29.4956,
    width: 356.357,
    height: 356.356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_2761_394708"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2761_394708",
    x: 0.474976,
    y: 32.1611,
    width: 403.538,
    height: 401.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_2761_394708"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2761_394708",
    x: 66.918,
    y: 142.31,
    width: 290,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2761_394708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2761_394708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2761_394708",
    x: 211.918,
    y: 73.3096,
    width: 290,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2761_394708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2761_394708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2761_394708",
    x: 116.918,
    y: 230.31,
    width: 290,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2761_394708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2761_394708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2761_394708",
    x1: 49.7652,
    y1: -44.2203,
    x2: 505.367,
    y2: 141.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2761_394708",
    x1: 172.529,
    y1: 131.496,
    x2: 337.665,
    y2: 318.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFE2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5BFF",
    stopOpacity: 0.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsEmptyState);
export default __webpack_public_path__ + "static/media/teams_emptyState.fd22957978017ee613863d62bd728a87.svg";
export { ForwardRef as ReactComponent };